/**
 * Set browser cookie
 * @param name
 * @param value
 * @param days
 */
export function setCookie(name, value, days) {
  let  expires = "";

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }

  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

/**
 * Delete browser cookie by name
 * @param name
 */
export function deleteCookie(name) {
  setCookie(name, "", {
    'max-age': -1
  })
}

/**
 * Get browser cookie by name
 * @param name
 * @returns {*}
 */
export function getCookie(name) {
  var matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}
